import { InputNumber } from "antd";

export interface ICustomNumberInputProps {
  onChange?: (value: number) => void;
  value?: number;
  bordered?: boolean;
  placeholder?: string;
}

export function CustomNumberInput(props: ICustomNumberInputProps) {
  const { value, onChange, bordered, placeholder } = props;
  return (
    <InputNumber
      bordered={bordered}
      className="w-100"
      type="number"
      value={value}
      onChange={(e) => {
        onChange && onChange(e);
      }}
      onBlur={(e) => {
        if (!e.target.value) {
          onChange && onChange(0);
        }
      }}
      placeholder={placeholder}
    />
  );
}
